import type { TLabel } from '@shared/types/label';

import { useState } from 'react';
import { object, string, ValidationError } from 'yup';
import labelApi from '../services/label-api';

const LabelSchema = object().shape({
  label: string().required('Label is required'),
  color: string()
    .matches(/^#([0-9A-F]{6}|[0-9A-F]{8}|[0-9A-F]{10})$/i, 'Invalid hex color')
    .required('Color is required'),
});

export const useLabelFormLogic = (data?: TLabel) => {
  const createLabel = labelApi.useCreate();
  const editLabel = labelApi.useUpdate();
  const [label, setLabel] = useState(data?.name || '');
  const [color, setColor] = useState(
    data?.hexa_color ? `${data?.hexa_color}` : `#4F46E5`
  );
  const [isColorOpen, setIsColorOpen] = useState<boolean>(data ? false : true);
  const [errors, setErrors] = useState<{
    label?: string;
    color?: string;
    opacity?: string;
  }>({});

  const handleColor = (color: string) => {
    setColor(color);
  };

  const handleSave = async () => {
    try {
      await LabelSchema.validate({ label, color }, { abortEarly: false });
      setErrors({}); // clear errors if valid
      if (data) {
        editLabel.mutate({ id: data.id, name: label, hexa_color: color });
      } else createLabel.mutate({ name: label, hexa_color: color });
      setLabel('');
    } catch (err) {
      if (err instanceof ValidationError) {
        const newErrors: { label?: string; color?: string } = {};

        err.inner.forEach((e) => {
          if (e.path && (e.path === 'label' || e.path === 'color')) {
            newErrors[e.path] = e.message;
          }
        });
        setErrors(newErrors);
        throw new Error();
      }
    }
  };

  return {
    label,
    setLabel,
    color,
    handleColor,
    isColorOpen,
    setIsColorOpen,
    errors,
    handleSave,
  };
};
